import forfeitFreeSpinsReward from "@/actions/rewards/forfeitFreeSpinsReward";

type Args = {
  id: string;
  onClose: () => void;
};

const useForfeitReward = ({ id, onClose }: Args) => {
  const handleForfeit = async () => {
    await forfeitFreeSpinsReward(id);
    onClose();
  };

  return { handleForfeit };
};

export default useForfeitReward;
